import { render, staticRenderFns } from "./ProjectCompaniesBox.vue?vue&type=template&id=8066312c&scoped=true&"
import script from "./ProjectCompaniesBox.vue?vue&type=script&lang=js&"
export * from "./ProjectCompaniesBox.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCompaniesBox.vue?vue&type=style&index=0&id=8066312c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8066312c",
  null
  
)

export default component.exports